import User from "../../../domain/entities/getUser";
import UserInfo from "../../../domain/entities/user";

export const buildDescriptionUserPayload = ({
    userInfo,
    latestUser,
    description,
}: {
    userInfo?: UserInfo;
    latestUser?: User;
    description: string;
}): UserInfo => {
    const {
        files,
        signup_photo_liveness_token,
        ...savedDetails
    } = userInfo || {};
    const hasSavedProfilePhotos = (latestUser?.profile_pictures?.length ?? 0) > 0;

    return {
        ...savedDetails,
        ...(!hasSavedProfilePhotos && files ? { files } : {}),
        ...(!hasSavedProfilePhotos && signup_photo_liveness_token
            ? { signup_photo_liveness_token }
            : {}),
        bio: description.trim(),
        country_lat: userInfo?.country_lat || userInfo?.lat,
        country_lng: userInfo?.country_lng || userInfo?.lng,
        status_onboarding: "1",
    };
};
